<div class="modal-wrap">
  <h3>비밀번호 변경</h3>
  <!-- 비밀번호 조건 : 영문 + 숫자 6자리 이상 -->
  <ul class="detail-view">
    <li>
      <p class="tit">현재 비밀번호</p>
      <input type="password" inputmode="text" [(ngModel)]="currentPw" minlength="6" placeholder="현재 비밀번호를 입력해주세요." />
    </li>
    <li>
      <p class="tit">새 비밀번호</p>
      <input
        type="password"
        inputmode="text"
        [(ngModel)]="newPw"
        (keyup)="pwExpression()"
        minlength="6"
        placeholder="새 비밀번호를 영문 + 숫자 6자리이상 입력해주세요."
      />
    </li>
    <li>
      <p class="tit">비밀번호 확인</p>
      <input
        type="password"
        inputmode="text"
        [(ngModel)]="confirmPw"
        (keyup)="rePwExpression()"
        minlength="6"
        placeholder="새 비밀번호를 한 번 더 입력해주세요."
      />
    </li>
  </ul>
  <div class="btn-wrap">
    <button type="button" class="btn btn-light" (click)="close()">취소</button>
    <button type="button" class="btn btn-primary" (click)="doChangePassword()" [disabled]="disabledCheck()">변경</button>
  </div>
</div>
